import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkFrontmatter from 'remark-frontmatter';
import rehypeHighlight from 'rehype-highlight';
import 'highlight.js/styles/github-dark.css';

/**
 * Leitor de Markdown (GitHub Flavored): títulos, tabelas, checklists, links,
 * citações, e blocos de código com syntax highlight (highlight.js).
 * `remark-frontmatter` reconhece o bloco `---` YAML dos soul.md (não renderiza).
 * Seguro por padrão: react-markdown não renderiza HTML cru e sanitiza URLs.
 */
export function Markdown({ text }: { text: string }) {
  return (
    <div className="md-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkFrontmatter]}
        rehypePlugins={[rehypeHighlight]}
        components={{
          a: ({ node: _node, ...props }) => <a {...props} target="_blank" rel="noreferrer" />,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
